import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { BaseWebService } from "../../../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class DeleteService {
    constructor(private _http: Http,
        private _basewebservice: BaseWebService,
        ) { }

     /**
     * Function to delete case study
     * @param  {any} caseStudyId contains caseStudy id.
     */
    delete = (requestData: any, assignedUser?: any): Observable<any> => {
        if (assignedUser) {
            requestData = requestData + '?assign_to=' + assignedUser;
        }
        return this._basewebservice.request( requestData, "delete")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getUserList(id: any) {
        return this._basewebservice.request("v1/user/" + id + "/assign_to_users/", "get", "delete")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * error.
     * @param  {Response|any} error error response.
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}